import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import './receipt.css'
import './report.css'

export const Receipts = ({ receiptModalData, closeReceiptModal, modSchema, envData }) => {
  const authDetails = JSON.parse(sessionStorage.getItem('auth')).state
  const orgDetails =
    authDetails?.dependeciesFormAPIS?.organization?.formData.length > 0 &&
    authDetails?.dependeciesFormAPIS?.organization?.formData[0]
  const [selectReceipt, setSelectReceipt] = React.useState(null)
  const [feeStatement, setFeeStatement] = React.useState(false)
  const [aY, setAY] = React.useState(null)
  const [aYDetails, setAYDetails] = React.useState(null)
  const [feeStatementData, setFeeStatementData] = React.useState(null)
  const [totalFee, setTotalFee] = React.useState(0)

  let selectYears
  const date = new Date()
  const year = date.getFullYear()
  const yearOptions = []
  for (var i = year - 20; i <= year; i++) {
    var option = document.createElement('option')
    option.value = option.innerHTML = i
    if (i === year) option.selected = true
    yearOptions.push(i)
  }
  selectYears = yearOptions

  const openFeeStatement = (e) => {
    setSelectReceipt(null)
    setTotalFee(0)
    let start, end
    if (modSchema.isSchoolModule) {
      start = JSON.parse(e).start
      end = JSON.parse(e).end
      setAY(JSON.parse(e).ay)
      const aYearId = receiptModalData.applicationAYClassSections.filter(
        (f) => f.academicYearId === JSON.parse(e).ayId,
      )
      setAYDetails(aYearId)
    } else {
      start = e + '-01-01'
      end = e + '-12-31'
    }
    const startDate = dayjs(start).format('YYYY-MM-DD 00:00:00')
    const endDate = dayjs(end).format('YYYY-MM-DD 23:59:59')
    const byDate = receiptModalData.feeReceipts.filter(
      (f) => f.feeReceivedDate >= startDate && f.feeReceivedDate <= endDate,
    )
    let totFee = 0
    byDate.map((f) => {
      totFee = totFee + f.feeAmount
    })
    setTotalFee(totFee)
    setFeeStatement(true)
    setFeeStatementData({ year: e, data: byDate })
  }

  const openFeeView = (e) => {
    setFeeStatement(false)
    setFeeStatementData(null)

    setSelectReceipt(e)
  }

  function numInWords(number) {
    const first = [
      '',
      'One ',
      'Two ',
      'Three ',
      'Four ',
      'Five ',
      'Six ',
      'Seven ',
      'Eight ',
      'Nine ',
      'Ten ',
      'Eleven ',
      'Twelve ',
      'Thirteen ',
      'Fourteen ',
      'Fifteen ',
      'Sixteen ',
      'Seventeen ',
      'Eighteen ',
      'Nineteen ',
    ]
    const tens = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety',
    ]
    const mad = ['', 'Thousand', 'Million', 'Billion', 'Trillion']
    let word = ''

    for (let i = 0; i < mad.length; i++) {
      let tempNumber = number % (100 * Math.pow(1000, i))
      if (Math.floor(tempNumber / Math.pow(1000, i)) !== 0) {
        if (Math.floor(tempNumber / Math.pow(1000, i)) < 20) {
          word = first[Math.floor(tempNumber / Math.pow(1000, i))] + mad[i] + ' ' + word
        } else {
          word =
            tens[Math.floor(tempNumber / (10 * Math.pow(1000, i)))] +
            '-' +
            first[Math.floor(tempNumber / Math.pow(1000, i)) % 10] +
            mad[i] +
            ' ' +
            word
        }
      }

      tempNumber = number % Math.pow(1000, i + 1)
      if (Math.floor(tempNumber / (100 * Math.pow(1000, i))) !== 0)
        word = first[Math.floor(tempNumber / (100 * Math.pow(1000, i)))] + 'hunderd ' + word
    }
    return word + ' ' + receiptModalData.feeReceipts[0].feeCurrency + ' Only'
  }
  console.log(aYDetails)
  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Fee Receipt
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                closeReceiptModal(false)
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-row">
              <div className="trtui-col-6 trtui-pt-2">
                <div className="trtui-row">
                  <div className="trtui-col-12">
                    <label>Select Receipt To View</label>
                    <select
                      className="trtui-form-control"
                      onChange={(e) => openFeeView(JSON.parse(e.target.value))}
                    >
                      <option value={''}>Select Receipt</option>
                      {receiptModalData.feeReceipts?.length > 0 &&
                        receiptModalData.feeReceipts.map((d, dInd) => (
                          <option
                            key={dInd}
                            value={JSON.stringify(d)}
                          >{`${d.feeType} - ${dayjs(d.feeReceivedDate).format('DD-MM-YYYY')}`}</option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="trtui-col-6 trtui-pt-2">
                <div className="trtui-row">
                  <label>Select Year To View Statement</label>
                  <select
                    className="trtui-form-control"
                    onChange={(e) => openFeeStatement(e.target.value)}
                  >
                    <option value={''}>Select Year</option>
                    {modSchema.isSchoolModule
                      ? authDetails?.dependeciesFormAPIS?.academicYears?.formData?.map(
                          (opt, optInd) => (
                            <option
                              key={optInd}
                              value={JSON.stringify({
                                start: opt.academicYearStartDate,
                                end: opt.academicYearEndDate,
                                ay: opt.academicYearName,
                                ayId: opt.academicYearId,
                              })}
                            >
                              {opt.academicYearName}
                            </option>
                          ),
                        )
                      : selectYears.reverse().map((opt, optInd) => (
                          <option key={optInd} value={opt}>
                            {opt}
                          </option>
                        ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="trtui-row trtui-justify-content-center" id="section-to-print">
              <div className="trtui-col-xxl-9">
                {selectReceipt !== null && !feeStatement && (
                  <div key={selectReceipt} className="trtui-card">
                    <form className="trtui-needs-validation" noValidate id="invoice_form">
                      <div className="trtui-card-body trtui-border-bottom trtui-border-bottom-dashed trtui-p-4">
                        <div className="trtui-row">
                          <div className="trtui-col-6">
                            <div className="trtui-profile-user trtui-mx-auto  trtui-mb-3">
                              <input
                                id="profile-img-file-input"
                                type="file"
                                className="trtui-profile-img-file-input"
                              />
                              <label
                                htmlFor="profile-img-file-input"
                                className="trtui-d-block"
                                tabIndex={0}
                              >
                                <span
                                  className="trtui-overflow-hidden trtui-border trtui-border-dashed trtui-d-flex trtui-align-items-center trtui-justify-content-center trtui-rounded"
                                  style={{ height: '60px', width: '256px' }}
                                >
                                  <img
                                    src={envData.REACT_APP_THEME_LOGO}
                                    className="trtui-card-logo trtui-card-logo-dark trtui-user-profile-image trtui-img-fluid"
                                    alt="logo dark"
                                  />
                                  <img
                                    src={envData.REACT_APP_THEME_LOGO}
                                    className="trtui-card-logo trtui-card-logo-light trtui-user-profile-image trtui-img-fluid"
                                    alt="logo light"
                                  />
                                </span>
                              </label>
                            </div>
                            <div>
                              <div>
                                <h4>{orgDetails.orgName}</h4>
                                <label htmlFor="companyAddress">
                                  {orgDetails.orgStreetAddress1}
                                </label>
                              </div>
                              {orgDetails.organizationDetails && (
                                <div className="trtui-mb-2">{`DCYF Provider Id: ${orgDetails.organizationDetails.id1} | SSPS Id: ${orgDetails.organizationDetails.id2} | EIN (Tax ID): ${orgDetails.organizationDetails.id4}`}</div>
                              )}
                            </div>
                          </div>
                          <div className="trtui-col-6 trtui-ms-auto">
                            <h3 className="trtui-mb-2">Fee Reciept</h3>
                            <div className="trtui-mb-2">
                              #: {selectReceipt.feeReceiptNumber} | Date:{' '}
                              {dayjs(selectReceipt.feeReceivedDate).format('MMM-DD-YYYY')}
                            </div>
                            <div>Fee Type: {selectReceipt.feeType}</div>
                          </div>
                        </div>
                      </div>
                      <div className="trtui-card-body trtui-p-4">
                        <div className="trtui-row trtui-g-3">
                          <div className="trtui-col-4">
                            <label htmlFor="invoicenoInput">Student Name</label>
                            <div>{receiptModalData.studentName}</div>
                          </div>
                          <div className="trtui-col-4">
                            <label htmlFor="choices-payment-status">Payment Mode</label>
                            <div>{selectReceipt.paymentMethod}</div>
                          </div>
                          <div className="trtui-col-4">
                            <div>
                              <label htmlFor="totalamountInput">Total Fee</label>
                              <div>${selectReceipt.feeAmount.toFixed(2)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="trtui-card-body">
                        <div className="trtui-table-responsive">
                          <table className="trtui-table trtui-table-borderless trtui-table-nowrap trtui-mb-0">
                            <tr>
                              <td>Amount in words: {numInWords(selectReceipt.feeAmount)}</td>
                              <td style={{ textAlign: 'right' }}>Receivers Signature</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <div className="trtui-card-body p-4" id="print-button">
                        <div className="trtui-table-responsive"></div>
                        <div className="trtui-hstack trtui-gap-2 trtui-justify-content-end trtui-d-print-none trtui-mt-4">
                          <button
                            type="button"
                            className="trtui-btn trtui-btn-success"
                            onClick={() => window.print()}
                          >
                            <i className="ri-printer-line trtui-align-bottom trtui-me-1" />{' '}
                            Download/Print Receipt
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
                {feeStatement && feeStatementData !== null && (
                  <>
                    <button
                      id="print-button"
                      type="button"
                      onClick={() => window.print()}
                      className="trtui-btn trtui-btn-primary trtui-mt-2 trtui-mb-2 trtui-py-1 trtui-font-16"
                    >
                      <i className="fa fa-print mr-2" />
                      Print
                    </button>
                    <div className="trtui-table-responsive" id="report-to-print-fr">
                      <table className="trtui-table trtui-table-bordered">
                        <tbody>
                          <tr>
                            <td className="trtui-text-center" colSpan={5}>
                              <h4>{orgDetails.orgName}</h4>
                              <label htmlFor="companyAddress">{orgDetails.orgStreetAddress1}</label>
                              {orgDetails.organizationDetails && (
                                <div className="trtui-mb-2">{`DCYF Provider Id: ${orgDetails.organizationDetails.id1} | SSPS Id: ${orgDetails.organizationDetails.id2} | EIN (Tax ID): ${orgDetails.organizationDetails.id4}`}</div>
                              )}
                              <h3 style={{ textDecoration: 'underline' }}>Fee Statement</h3>
                            </td>
                          </tr>
                          <tr>
                            <td className="trtui-mt-2" colSpan={4}>
                              <b>Student Name: {receiptModalData.studentName}</b>
                            </td>
                            <td className="trtui-mt-2" colSpan={3}>
                              <b>Year: {modSchema.isSchoolModule ? aY : feeStatementData.year}</b>
                            </td>
                          </tr>
                          <tr>
                            <td className="trtui-mt-2">Date</td>
                            <td className="trtui-mt-2">Type</td>
                            <td className="trtui-mt-2">Payment Mode</td>
                            <td className="trtui-mt-2">Paid By</td>
                            <td className="trtui-mt-2">Amount</td>
                          </tr>
                          {feeStatementData !== null &&
                            feeStatementData.data.length > 0 &&
                            feeStatementData.data.map((data, dataIndex) => (
                              <tr key={dataIndex}>
                                <td className="trtui-mt-2">
                                  {dayjs(data.feeReceivedDate).format('DD-MM-YYYY')}
                                </td>
                                <td className="trtui-mt-2">{data.feeType}</td>
                                <td className="trtui-mt-2">{data.paymentMethod}</td>
                                <td className="trtui-mt-2">{data.feeReceivedFrom}</td>
                                <td className="trtui-mt-2">
                                  {data.feeCurrency}
                                  {data.feeAmount.toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          <tr>
                            <td colSpan={4} className="trtui-mt-2">
                              <strong>Total Amount Paid</strong>
                              {modSchema.isSchoolModule && (
                                <>
                                  <br />
                                  Balance: {feeStatementData?.data[0]?.feeCurrency}
                                  {(
                                    aYDetails[0]?.AY_TotalFee -
                                    (aYDetails[0]?.AY_External_ScholarShips + totalFee)
                                  ).toFixed(2)}
                                </>
                              )}
                            </td>
                            <td className="trtui-mt-2">
                              <strong>
                                {feeStatementData?.data[0]?.feeCurrency}
                                {totalFee.toFixed(2) || 0}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {/* {getData.data?.formData && getData.data?.formData > 0 ? (
							) : (
								"No Data!"
							)} */}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Receipts.propTypes = {
  envData: PropTypes.object,
  receiptModalData: PropTypes.object,
  closeReceiptModal: PropTypes.func,
  modSchema: PropTypes.object,
}
